import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useSignOut } from '../lib/auth-helper'

function SignOutButton() {
    const [isHover, setIsHover] = useState(false)
    const signOut = useSignOut()
    const navigate = useNavigate()

    const signOutClick = () => {
        signOut().then(navigate('/'))
    }

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const onMouseLeave = () => {
        setIsHover(false)
    }

    const customButtonStyle = {
        backgroundColor: "var(--nav-bar)",
        textAlign: "end",
        color: isHover ? "var(--primary)" : "var(--white)",
        boxShadow: "none",
        paddingBottom: "5px",
        border: "none"
    }

    return (
        <Button style={customButtonStyle}
            onClick={signOutClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={onMouseLeave} >
            <i className="bi bi-box-arrow-right" />
            <span className="d-none d-md-inline">&nbsp;Sign Out</span>
        </Button>
    )
}

export default SignOutButton
